// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Calendar_inputField__DHgIi {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  margin-bottom: 8px;
  width: 100%;
  min-width: 150px;
  cursor: pointer;
}

.Calendar_label__al6bD {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 95%;
  margin-left: 15px;
}

.Calendar_rdp__AXzrr {
  --rdp-cell-size: 40px; /* Size of the day cells. */
  --rdp-caption-font-size: 18px; /* Font size for the caption labels. */
  --rdp-accent-color: #11205e !important; /* Accent color for the background of selected days. */
  --rdp-background-color: #5271ec !important; /* Background color for the hovered/focused elements. */
  --rdp-accent-color-dark: #11205e !important; /* Accent color for the background of selected days (to use in dark-mode). */
  --rdp-background-color-dark: #5271ec !important; /* Background color for the hovered/focused elements (to use in dark-mode). */
  --rdp-outline: 2px solid var(--rdp-accent-color); /* Outline border for focused elements */
  --rdp-outline-selected: 3px solid var(--rdp-accent-color); /* Outline border for focused _and_ selected elements */
  --rdp-selected-color: #fff; /* Color of selected day text */
  text-transform: capitalize !important;
}

.Calendar_field__4QlNk {
  --rdp-cell-size: 40px; /* Size of the day cells. */
  --rdp-caption-font-size: 18px; /* Font size for the caption labels. */
  --rdp-accent-color: #11205e !important; /* Accent color for the background of selected days. */
  --rdp-background-color: #5271ec !important; /* Background color for the hovered/focused elements. */
  --rdp-accent-color-dark: #11205e !important; /* Accent color for the background of selected days (to use in dark-mode). */
  --rdp-background-color-dark: #5271ec !important; /* Background color for the hovered/focused elements (to use in dark-mode). */
  --rdp-outline: 2px solid var(--rdp-accent-color); /* Outline border for focused elements */
  --rdp-outline-selected: 3px solid var(--rdp-accent-color); /* Outline border for focused _and_ selected elements */
  --rdp-selected-color: #fff; /* Color of selected day text */
  text-transform: capitalize !important;
}


.Calendar_wrapperTooltip__rgAen.Calendar_wrapperTooltip__rgAen {
  background-color: #fff;
  color: var(--color-black-main, #364954);
  padding: 8px;
  border-radius: 8px;
  z-index: 1;

}

.Calendar_inputContainer__4uGfK {
  position: relative;
  
}

.Calendar_field__4QlNk {
  width: 100%;
  padding-right: 24px; 
}

@keyframes Calendar_fadeIn__jmPvI {
  from {
    opacity: 0;
    transform: translateY(-50%) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
}

.Calendar_clearButton__ZRH6v {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 25px;
  cursor: pointer;
  color: #999;
  opacity: 0;
  animation: Calendar_fadeIn__jmPvI 0.3s forwards;

  &:hover {
    color: #ff0000;
  }
}


.Calendar_arrow__BxTqe {
  position: absolute;
  right: -6px;
  top: 30%;
  scale: 1.40;
  display: inline-block;
  margin: 0 1rem;
  pointer-events: none; 
}

/* .arrow > span {
  position: absolute;
  width: 0.75rem;
  height: 0.1rem;
  background-color: #999;
  display: inline-block;
  transition: all 0.2s ease;
}

.arrow span:first-child {
  left: 0;
  transform: rotate(45deg) translateY(-50%);
}

.arrow span:last-child {
  right: 0;
  transform: rotate(-45deg) translateY(-50%);
}

.arrow.active span:first-child {
  transform: rotate(-45deg) translateY(-50%);
}

.arrow.active span:last-child {
  transform: rotate(45deg) translateY(-50%);
}  */

.Calendar_calendarContainer__iT42R {
  display: flex;
  gap: 20px;
}
.Calendar_calendarContainer__iT42R > div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/shared/Ui/Calendar/Calendar.module.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB,EAAE,2BAA2B;EAClD,6BAA6B,EAAE,sCAAsC;EACrE,sCAAsC,EAAE,sDAAsD;EAC9F,0CAA0C,EAAE,uDAAuD;EACnG,2CAA2C,EAAE,4EAA4E;EACzH,+CAA+C,EAAE,6EAA6E;EAC9H,gDAAgD,EAAE,wCAAwC;EAC1F,yDAAyD,EAAE,uDAAuD;EAClH,0BAA0B,EAAE,+BAA+B;EAC3D,qCAAqC;AACvC;;AAEA;EACE,qBAAqB,EAAE,2BAA2B;EAClD,6BAA6B,EAAE,sCAAsC;EACrE,sCAAsC,EAAE,sDAAsD;EAC9F,0CAA0C,EAAE,uDAAuD;EACnG,2CAA2C,EAAE,4EAA4E;EACzH,+CAA+C,EAAE,6EAA6E;EAC9H,gDAAgD,EAAE,wCAAwC;EAC1F,yDAAyD,EAAE,uDAAuD;EAClH,0BAA0B,EAAE,+BAA+B;EAC3D,qCAAqC;AACvC;;;AAGA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,UAAU;;AAEZ;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,+CAA+B;;EAE/B;IACE,cAAc;EAChB;AACF;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;IAyBI;;AAEJ;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX","sourcesContent":[".inputField {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  margin-bottom: 8px;\n  width: 100%;\n  min-width: 150px;\n  cursor: pointer;\n}\n\n.label {\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 95%;\n  margin-left: 15px;\n}\n\n.rdp {\n  --rdp-cell-size: 40px; /* Size of the day cells. */\n  --rdp-caption-font-size: 18px; /* Font size for the caption labels. */\n  --rdp-accent-color: #11205e !important; /* Accent color for the background of selected days. */\n  --rdp-background-color: #5271ec !important; /* Background color for the hovered/focused elements. */\n  --rdp-accent-color-dark: #11205e !important; /* Accent color for the background of selected days (to use in dark-mode). */\n  --rdp-background-color-dark: #5271ec !important; /* Background color for the hovered/focused elements (to use in dark-mode). */\n  --rdp-outline: 2px solid var(--rdp-accent-color); /* Outline border for focused elements */\n  --rdp-outline-selected: 3px solid var(--rdp-accent-color); /* Outline border for focused _and_ selected elements */\n  --rdp-selected-color: #fff; /* Color of selected day text */\n  text-transform: capitalize !important;\n}\n\n.field {\n  --rdp-cell-size: 40px; /* Size of the day cells. */\n  --rdp-caption-font-size: 18px; /* Font size for the caption labels. */\n  --rdp-accent-color: #11205e !important; /* Accent color for the background of selected days. */\n  --rdp-background-color: #5271ec !important; /* Background color for the hovered/focused elements. */\n  --rdp-accent-color-dark: #11205e !important; /* Accent color for the background of selected days (to use in dark-mode). */\n  --rdp-background-color-dark: #5271ec !important; /* Background color for the hovered/focused elements (to use in dark-mode). */\n  --rdp-outline: 2px solid var(--rdp-accent-color); /* Outline border for focused elements */\n  --rdp-outline-selected: 3px solid var(--rdp-accent-color); /* Outline border for focused _and_ selected elements */\n  --rdp-selected-color: #fff; /* Color of selected day text */\n  text-transform: capitalize !important;\n}\n\n\n.wrapperTooltip.wrapperTooltip {\n  background-color: #fff;\n  color: var(--color-black-main, #364954);\n  padding: 8px;\n  border-radius: 8px;\n  z-index: 1;\n\n}\n\n.inputContainer {\n  position: relative;\n  \n}\n\n.field {\n  width: 100%;\n  padding-right: 24px; \n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-50%) scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(-50%) scale(1);\n  }\n}\n\n.clearButton {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  font-size: 25px;\n  cursor: pointer;\n  color: #999;\n  opacity: 0;\n  animation: fadeIn 0.3s forwards;\n\n  &:hover {\n    color: #ff0000;\n  }\n}\n\n\n.arrow {\n  position: absolute;\n  right: -6px;\n  top: 30%;\n  scale: 1.40;\n  display: inline-block;\n  margin: 0 1rem;\n  pointer-events: none; \n}\n\n/* .arrow > span {\n  position: absolute;\n  width: 0.75rem;\n  height: 0.1rem;\n  background-color: #999;\n  display: inline-block;\n  transition: all 0.2s ease;\n}\n\n.arrow span:first-child {\n  left: 0;\n  transform: rotate(45deg) translateY(-50%);\n}\n\n.arrow span:last-child {\n  right: 0;\n  transform: rotate(-45deg) translateY(-50%);\n}\n\n.arrow.active span:first-child {\n  transform: rotate(-45deg) translateY(-50%);\n}\n\n.arrow.active span:last-child {\n  transform: rotate(45deg) translateY(-50%);\n}  */\n\n.calendarContainer {\n  display: flex;\n  gap: 20px;\n}\n.calendarContainer > div {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputField": `Calendar_inputField__DHgIi`,
	"label": `Calendar_label__al6bD`,
	"rdp": `Calendar_rdp__AXzrr`,
	"field": `Calendar_field__4QlNk`,
	"wrapperTooltip": `Calendar_wrapperTooltip__rgAen`,
	"inputContainer": `Calendar_inputContainer__4uGfK`,
	"clearButton": `Calendar_clearButton__ZRH6v`,
	"fadeIn": `Calendar_fadeIn__jmPvI`,
	"arrow": `Calendar_arrow__BxTqe`,
	"calendarContainer": `Calendar_calendarContainer__iT42R`
};
export default ___CSS_LOADER_EXPORT___;
